import { vxm } from '@/store';

export type LinkableAconexDocumentProps = {
  projectId: string;
  documentId: string;
  originalAconexSite: string | null;
};

export function getAconexDocumentLink({ projectId, documentId, originalAconexSite }: LinkableAconexDocumentProps) {
  const aconexHost = originalAconexSite || vxm.userProfile.userProfile?.aconexUserInformation?.userSite;
  if (!aconexHost) {
    return null;
  }
  // I don't know what the date and time are supposed to be here
  // in the Aconex UI, looking today from my machine, all I see is 20241216.0001. Which doesn't smell much like a date and time of a document. More like a date and time version of the document viewer itself?
  // It is not related to the document at all. It is the build number. I was hacking the url and got an error about a missing page
  // which said "Release: 24.11.500, build: 20241216.0001" which matches the stuff in the urls
  // So..
  //   We could use the current date. It works, but it'll confuse their tech support until they go "ah... it's the date of the request"
  //   We could use something related to the date the document was imported. It'd work, it'd be a lie, it'd be even more confusing than the above.
  //   We could see if we can sniff the version number somehow from somewhere.
  //     It comes back in the body of the response if you request the dud path https://au1.aconex.com/rsrc/en_AU_DOC/document/view/index.html
  //     we could parse it out of there if we needed to. This would be The Solution in the future.
  //     We could make the call serverside, cache it for a while, request a few times a day, all sorts of options.
  //     We could make the call client side and store it in an aconex vuex module
  //     We could use an url like https://au1.aconex.com/rsrc/checking-version and make it obvious that these are not really 404s.
  //   We could just pass a zero. It works. I think I like this the best. Their support is going to look at it and go "oh, not filled in"
  const date = '0';
  const time = '0';
  return `${aconexHost}/rsrc/${date}.${time}/en_AU_DOC/document/view/index.html?ControlledDocument_ID=${documentId}&ControlledDocument_projectID=${projectId}`;
}

export type LinkableAconexMailProps = {
  mailId: string;
  projectId: string;
  originalAconexSite: string | null;
};

export function getAconexMailLink({ mailId, projectId, originalAconexSite }: LinkableAconexMailProps) {
  const aconexHost = originalAconexSite || vxm.userProfile.userProfile?.aconexUserInformation?.userSite;
  if (!aconexHost) {
    return null;
  }

  return `${aconexHost}/ViewCorrespondence?Correspondence_ID=${mailId}&PROJECT_ID=${projectId}`;
}
